import { Icon } from "../../../../elements/Icon";
import { arrowCircleRight } from "../../../../elements/Icon/Icon.types";
import { styles } from "./BulletPoints.style";

export interface BulletPointsProps {
  bulletPoints: string[];
}

export const BulletPoints = (props: BulletPointsProps) => {
  const { bulletPoints } = props;
  return (
    <div className={styles.root()}>
      {bulletPoints.map((element) => {
        return (
          <span className={styles.item()} key={`bullet-point-${element}`}>
            <Icon className={styles.icon()} icon={arrowCircleRight} />
            <p>{element}</p>
          </span>
        );
      })}
    </div>
  );
};
